import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'components/inputs/Select';
import * as Yup from 'yup';
import * as _ from 'lodash';
import { CREATE_ZONE, UPDATE_ZONE, FETCH_REGION } from 'actions/address';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';

const ZoneForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();

  const zoneDetail = useSelector((state) => state.zone.zoneDetail);
  const allRegions = useSelector((state) => state.region.regions);
  const isLoading = useSelector((state) => state.zone.isLoading);
  const regionPage = useSelector((state) => state.region.page);
  const regionTotalPage = useSelector((state) => state.region.totalPages);

  const addZone = useCallback((data) => {
    dispatch({
      type: CREATE_ZONE.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateZone = useCallback((data) => {
    dispatch({
      type: UPDATE_ZONE.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const getAllRegion = useCallback((data = {}) => {
    dispatch({ type: FETCH_REGION.REQUEST, payload: data });
  }, []);

  useEffect(() => {
    getAllRegion();
  }, []);

  const ZoneSchema = Yup.object().shape({
    region: Yup.string().required('Region is required'),
    name: Yup.string()
      .required('Zone Name is required')
      .strict(true)
      .trim('Space not allowed')
      .max(100, 'Max limit reached'),
  });

  const initialValues = isEdit
    ? { ...zoneDetail, region: _.get(zoneDetail, 'region.id', '') }
    : {
        name: '',
        region: '',
      };
  return (
    <React.Fragment>
      <div className="country-form-page__main">
        <Card>
          <div className="country-form-header__block">
            <div className="country-header-name">
              <span>
                {isEdit ? 'Edit' : 'Add'} Zone
              </span>
            </div>
            <div className="close-btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
          </div>
          <div className="country-form-body__block">
            <div className="country-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={ZoneSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    updateZone(values);
                  } else {
                    addZone(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, setFieldValue, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg={12}>
                        <Select
                          isRequired
                          label="Region Name"
                          options={_.map(allRegions, (item) => {
                            return { label: item.name, value: item.id };
                          })}
                          placeholder="Select Region"
                          onMenuScrollDown={true}
                          getDataOnScrollDown={getAllRegion}
                          page={regionPage}
                          totalPage={regionTotalPage}
                          name="region"
                          value={_.get(values, 'region')}
                          onChange={(val) => setFieldValue(`region`, val)}
                          error={errors.region && touched.region ? errors.region : null}
                        />
                      </Col>
                      <Col lg={12}>
                        <TextInput
                          isRequired
                          label="Zone Name"
                          placeholder="Zone Name"
                          name="name"
                          value={_.get(values, 'name')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn-block">
                      <Button className="country-form-btn cancel_btn" onClick={onClose}>
                        Cancel
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="country-form-btn create-btn">
                        {isEdit ? 'Update' : 'Create'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
ZoneForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default ZoneForm;
